const CURRENCY_SYMBOLS: Record<string, string> = {
  BDT: "\u09F3",
  USD: "$",
  EUR: "\u20AC",
  GBP: "\u00A3",
  INR: "\u20B9",
};

export function formatPrice(
  amount: number,
  currency = "BDT",
  locale: string = "en-US",
): string {
  const symbol = CURRENCY_SYMBOLS[currency] ?? currency;
  return `${symbol}${new Intl.NumberFormat(locale).format(amount)}`;
}

/**
 * A taka price in the page's own digits (`LN-WEB02`): ৳৬,৯৯৯ on `/bn`,
 * ৳6,999 on `/en`. A taka amount next to Bangla words printed Latin digits on
 * the Learn pages because `formatPrice` defaults to en-US; the Ambassador pages
 * already pass `bn-BD` the same way. Any other currency goes through
 * `formatPrice` unchanged.
 */
export function formatLocalPrice(amount: number, currency: string, locale: string): string {
  return currency === "BDT"
    ? formatPrice(amount, currency, locale === "bn" ? "bn-BD" : "en-US")
    : formatPrice(amount, currency);
}

export function calculateDiscount(list: number, sale: number): number {
  if (!sale || sale >= list) return 0;
  return Math.round(((list - sale) / list) * 100);
}
